import { Backdrop, Box, CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Server } from '../../services/Server';
import { textLabels } from '../../constants';

type Props = {
  url: string;
  method: string;
  params?: Record<string, unknown>;
  body: object;
  properties: unknown;
  upload?: unknown;
  title?: string;
};

type ApiError = {
  response?: {
    data?: {
      title?: string;
      detail?: { loc?: string[]; msg: string }[];
    };
  };
};

const SMTInfo = ({ url, method, params, body }: Props) => {
  const { URL_BASE, getFromServerWithParams, postToServerWithParams } = Server();

  const {
    data: dataFromApi = {},
    isLoading: isLoading,
    isError: isError,
    error: error,
  } = useQuery({
    queryKey: ['smt-info-', url],
    queryFn: () =>
      method === 'get'
        ? getFromServerWithParams<Record<string, string | number>>(`${URL_BASE}${url}`, params ?? {})
        : postToServerWithParams<Record<string, string | number>>(`${URL_BASE}${url}`, params ?? {}, body),
    enabled: true,
  });

  // if (isError) {
  //   handleError(error);
  // }

  const apiError = error as ApiError | null;

  return (
    <>
      <Box sx={{ pl: 1, pr: 1 }}>
        {isLoading ? (
          <Backdrop open={true} sx={{ backgroundColor: 'rgba(255, 255, 255, 0.5)', width: '100%', height: '50px', position: 'relative' }}>
            <CircularProgress />
          </Backdrop>
        ) : dataFromApi && !isError ? (
          <ul>
            {Object.keys(dataFromApi)?.map((item: string) => (
              <li key={item}>
                <b>{textLabels?.[item as keyof typeof textLabels]}:</b> {dataFromApi[item as keyof typeof dataFromApi]}
              </li>
            ))}
          </ul>
        ) : (
          <>
            {apiError?.response?.data?.title
              ? apiError.response?.data?.title
              : apiError?.response?.data?.detail?.[0].loc?.join('-') + ': ' + apiError?.response?.data?.detail![0].msg}
          </>
        )}
      </Box>
    </>
  );
};

export default SMTInfo;
